import store from "../store/index";
//-----------
// race call
//-----------
export default async function useRaceCall(api_parms) {
  // console.log("---------------------")
  // console.log("IN useRaceCall....")
  let slug = "";
  //--------------
  // access store
  //--------------
  const this_store = store;
  //-----------------
  // call race setup
  //-----------------
  const race = await this_store
    .dispatch("races/editRace", api_parms)
    .then((response) => {
      if (api_parms.payload.slug == "") {
        slug = response.data.slug;
      } else {
        slug = api_parms.payload.slug;
      }
      return response
    });
  //--------------------------
  // setup image update parms
  //--------------------------
  let api_parms_image = {
    slug: slug,
    image_file: api_parms.payload.image_file,
  };
  //-------------------------
  // call update image setup
  //-------------------------
  const image = await this_store.dispatch(
    "races/changeRaceImage",
    api_parms_image
  );
  //--------------------
  // return call values
  //--------------------
  return [race.data, image];
}
